import { Component } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-lista-topic',
  templateUrl: './lista-topic.page.html',
  styleUrls: ['./lista-topic.page.scss']
})
export class ListaTopicPage {

  id = '';
  listaGenerar: string[];
  romanji: string[];
  strokes_order: string[];
  unicodes: string[];
  topic: string;

  dict_iter: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  constructor(private _params: NavParams, private _viewCtrl: ModalController) {
    this.id = this._params.get('titulo');
    this.romanji = this._params.get('dec');
    this.listaGenerar = this._params.get('characters');
    this.strokes_order = this._params.get('strokes');
    this.unicodes = this._params.get('unicodes');
  }

  practice(starter: string, dec_starter: string) {
    const ind = this.getIndex(dec_starter);
    this._viewCtrl.dismiss({
      selected: starter,
      selected_dec: dec_starter,
      selected_stroke: this.concatTerms(this.strokes_order)[ind],
      selected_unicode: this.concatTerms(this.unicodes)[ind],
    });
  }

  getIndex(id: string) {
    const dec = this.concatTerms(this.romanji);
    for (let k = 0; k < dec.length; k++) {
      if (dec[k] === id) {
        return k;
      }
    }
  }

  goBack() {
    this._viewCtrl.dismiss();
  }

  concatTerms(_x) {
    let _dest: string[] = [];
    let iter: number;
    if (this.topic === 'Katakana') { iter = 11; } else { iter = 11; }
    for (let j = 0; j < iter; j++) {
      if (j === 0) {
        _dest = _x[j].concat(_x[j + 1]);
      } else if (j === iter - 1) {
        _dest = _dest.concat(_x[j]);
      } else {
        const aux = _x[j].concat(_x[j + 1]);

        _dest = _dest.concat(aux);
      }
      j += 1;
    }
    // Remove empty elements
    for (let i = _dest.length - 1; i >= 0; i--) {
      if (_dest[i] === '') {
        _dest.splice(i, 1);
      }
    }
    return _dest;
  }
}
